import {useBlocker, useNavigate} from "react-router-dom";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {BaSeButton} from "@base/react";
import ModalDefault from "../modals/modal-default";
import ApiGeneral from "../../services/general";
import {getCurrentCNPJ} from "../../services/utils";

const useRouterPrompt = (when = false) => {

  const blocker = useBlocker(
    ({ currentLocation, nextLocation, historyAction }) => {
      return when && currentLocation.pathname !== nextLocation.pathname
    }
  )

  return { isPrompting: blocker.state === "blocked", block: blocker.reset, navigate: blocker.proceed }
}

const RouterPrompt = ({
                        hasUnsavedChanges,
                        planningId = null,
                        currentCnpj = null,
                        checkForAbandonment = false,
                        forceShowDialog = false,
                        callbackCancel, callbackConfirm,
                        description = "Para prosseguir com o cálculo do seu planejamento, a soma dos percentuais informados deve ser igual a 100%."
                      }) => {
  const [show, setShow] = useState(false);
  const [showExternalPrompt, setShowExternalPrompt] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);
  const pendingNavigationRef = useRef(null);
  const routerNavigate = useNavigate();
  const shouldBlockNavigation = !isLeaving && (show || checkForAbandonment);
  const { isPrompting, block, navigate } = useRouterPrompt(shouldBlockNavigation)

  useEffect(() => {
    setShow(hasUnsavedChanges)
  }, [hasUnsavedChanges])

  const fnAbandonment = useCallback(async () => {
    if (!checkForAbandonment || !planningId) return

    await ApiGeneral().sendDigitalMoments('plan_without_results', {
      plan_id: planningId,
      cnpj: currentCnpj
    })
  }, [checkForAbandonment, planningId, currentCnpj])

  const runAbandonmentAndContinue = useCallback(async (continueNavigation) => {
    if (isLeaving) return

    setIsLeaving(true)

    try {
      await fnAbandonment()
    } finally {
      continueNavigation?.()
    }
  }, [fnAbandonment, isLeaving])

  const handleCancel = () => {
    if (showExternalPrompt) {
      pendingNavigationRef.current = null;
      setShowExternalPrompt(false);
      return
    }

    block?.()
  }
  const handleConfirm = () => {
    if (forceShowDialog) {
      callbackConfirm?.()
      return
    }

    if (showExternalPrompt) {
      runAbandonmentAndContinue(pendingNavigationRef.current)
      return
    }

    runAbandonmentAndContinue(navigate)
  }

  // useEffect(() => {
  //   if (!checkForAbandonment) return
  //
  //   const handleBeforeUnload = () => {
  //     fnAbandonment()
  //   }
  //
  //   window.addEventListener("beforeunload", handleBeforeUnload)
  //
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload)
  //   }
  // }, [checkForAbandonment, fnAbandonment])
  useEffect(() => {
    if (!checkForAbandonment) return

    const handleClick = (event) => {
      if (event.defaultPrevented || event.button !== 0) return

      const anchor = event.target.closest?.("a[href]")

      if (!anchor) return

      const href = anchor.getAttribute("href")
      const scriptProtocol = ["javascript", ":"].join("")

      if (
        !href ||
        href.startsWith("#") ||
        href.startsWith(scriptProtocol) ||
        anchor.hasAttribute("download")
      ) {
        return
      }

      const target = anchor.getAttribute("target")
      const url = new URL(anchor.href, window.location.href)
      const isSameOrigin = url.origin === window.location.origin
      const isSamePath = isSameOrigin && url.pathname === window.location.pathname

      if (isSamePath && url.hash) return

      const continueNavigation = () => {
        if (target && target !== "_self") {
          window.open(url.href, target, "noopener,noreferrer")
          setIsLeaving(false)
          setShowExternalPrompt(false)
          pendingNavigationRef.current = null
          return
        }

        if (isSameOrigin) {
          routerNavigate(`${url.pathname}${url.search}${url.hash}`)
          setIsLeaving(false)
          setShowExternalPrompt(false)
          pendingNavigationRef.current = null
          return
        }

        window.location.href = url.href
      }

      event.preventDefault()
      event.stopPropagation()
      pendingNavigationRef.current = continueNavigation

      if (show) {
        setShowExternalPrompt(true)
        return
      }

      runAbandonmentAndContinue(continueNavigation)
    }

    document.addEventListener("click", handleClick, true)

    return () => {
      document.removeEventListener("click", handleClick, true)
    }
  }, [checkForAbandonment, routerNavigate, runAbandonmentAndContinue, show])
  useEffect(() => {
    if (!isPrompting || show) return

    runAbandonmentAndContinue(navigate)
  }, [isPrompting, navigate, runAbandonmentAndContinue, show])

  return (
    <ModalDefault
      title="Atenção!"
      callBackClose={forceShowDialog ? callbackCancel : handleCancel}
      show={forceShowDialog || (show && isPrompting) || showExternalPrompt}
      classCustom="dialog-prompt"
    >
      <p className="dialog-prompt__description">
        <strong>Tem certeza de que deseja sair?</strong> <br/><br/>
        { description }
      </p>
      <div className="dialog-prompt__buttons">
        <BaSeButton
          type="secondary"
          buttonType="button"
          onClick={forceShowDialog ? callbackCancel : handleCancel}
          color="#2E5DE6"
          size="medium"
          value="Continuar Editando"
          width="auto"
        />
        <BaSeButton
          buttonType="button"
          color="#2E5DE6"
          size="medium"
          value={isLeaving ? "Saindo..." : "Confirmar Saída"}
          width="auto"
          onClick={handleConfirm}
        />
      </div>
    </ModalDefault>
  )
}

export default RouterPrompt
